import { DashboardApiService } from './service';
import ApiClientFactory from '../../api/client-factory';

const service = new DashboardApiService(ApiClientFactory());

export function DashboardApiServiceFactory(): typeof service {
  return service;
}
